import { useScrollReset } from '@perpay-web/hooks/useScrollReset';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './FocusLayout.scss';

/**
 * @param children - could be any JSX elements, but designed for use with accompanying subcomponents, example usage:
 *  <FocusLayout>
        <FocusHeader
            leftButtonElement={<BackButton />}
            rightButtonElement={<InfoButton />}
        />
        <FocusContent>{overflowText}</FocusContent>
        <FocusFooter>{button}</FocusFooter>
    </FocusLayout>
 * @param className - Styling overrides for wrapper, see __public classes in FocusLayout.scss for common cases
 * @param shouldResetScroll - resets scroll to top of page on reload, desired behavior for most of our flows using this layout
 */
const FocusLayout = ({
    children,
    className = '',
    shouldResetScroll = true,
    id = 'focus-layout',
}) => {
    useScrollReset(shouldResetScroll);

    return (
        <div
            className={getClassName(styles['focus-layout'], className)}
            id={id}
        >
            {children}
        </div>
    );
};

export default FocusLayout;
